// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'




Vue.config.productionTip = false

/*
  Variables de entorno
*/
Vue.config.PITZ = process.env
// Vue.config.PITZ.API_URL


/*
  MATERIAL DESIGN
*/
import Vuetify from 'vuetify'
import('../node_modules/vuetify/dist/vuetify.min.css')
Vue.use(Vuetify)

/*
  VUEX
*/
/*VUEX*/
import store from './store/index'
import { sync } from 'vuex-router-sync'
sync(store, router)

/* CKEditor */
import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use( CKEditor );

/*
  AXIOS HTTP Request Library
*/
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = Vue.config.PITZ.API_URL
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post['Accept'] = 'application/json'
Vue.use(VueAxios, axios)


/*
  VUE SESSION "para guardar variables de sesion"
*/
import VueSession from 'vue-session'


/*
  GOOGLE MAPS
*/
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyChrneyjIui58UV6hFoF8iQxiSmP0iLZSE',
    libraries: 'places,drawing,visualization', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})


// Registro de componentes globales
import ErrorModal from '@/components/helpers/modals/ErrorModal'
Vue.component('error-modal', ErrorModal)
import ImageModal from '@/components/helpers/modals/ImageModal'
Vue.component('image-modal', ImageModal)
import ConfirmModal from '@/components/helpers/modals/ConfirmModal'
Vue.component('confirm-modal', ConfirmModal)
import SimpleNumericInput from '@/components/helpers/modals/SimpleNumericInput'
Vue.component('simple-numeric-input', SimpleNumericInput)
import Loader from '@/components/helpers/modals/Loader'
Vue.component('loader', Loader)
import GeneralInformation from '@/components/pages/tournaments/general_information/GeneralInformation'
Vue.component('general-information', GeneralInformation)
import Teams from '@/components/pages/tournaments/teams/Teams'
Vue.component('teams', Teams)
import TournamentCalendar from '@/components/pages/tournaments/tournament_calendar/TournamentCalendar'
Vue.component('tournament-calendar', TournamentCalendar)
import Scores from '@/components/pages/tournaments/scores/Scores'
Vue.component('scores', Scores)
import Statistics from '@/components/pages/tournaments/statistics/Statistics'
Vue.component('statistics', Statistics)
import AccountStatus from '@/components/pages/tournaments/account_status/AccountStatus'
Vue.component('account-status', AccountStatus)
import Requests from '@/components/pages/requests/requests'
Vue.component('requests', Requests)
import Partnering from '@/components/pages/partnering/partnering'
Vue.component('partnering', Partnering)
import TournamentRegistrationForm from '@/components/pages/tournaments/tournament_registration/tournamentRegistrationForm'
Vue.component('tournament-registration-form', TournamentRegistrationForm)
import AddOptionsEvidenceModal from '@/components/pages/sponsorships/addOptionsEvidenceModal'
Vue.component('add-options-evidence-modal', AddOptionsEvidenceModal)
import AddEvidenceModal from '@/components/pages/sponsorships/addEvidenceModal'
Vue.component('add-evidence-modal', AddEvidenceModal)
import AddSectionModal from '@/components/pages/sponsorships/addSectionModal'
Vue.component('add-section-modal', AddSectionModal)
import AddContentSectionModal from '@/components/pages/sponsorships/addContentSectionModal'
Vue.component('add-content-section-modal', AddContentSectionModal)
import Sanctions from '@/components/pages/tournaments/sanctions/Sanctions'
Vue.component('sanctions', Sanctions)
Vue.use(VueSession)


/*LANG*/
import i18n from './lang/lang'

export const i18N = i18n

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  /*components: {
    App
  },*/
  render: h => h(App),
  created() {
    //do something after creating vue instance
    console.log("ENV",Vue.config.PITZ.NODE_ENV)
    Vue.config.session = this.$session
  }


})



// WEBPACK FOOTER //
// ./src/main.js